import { useEffect, useState } from "react";

export default function useIsOutbrainEnabled(): boolean {
  const [isOutbrainEnabled, setIsOutbrainEnabled] = useState<boolean>(true);

  useEffect(() => {
    if (typeof window === "undefined") return;

    // Initial check
    setIsOutbrainEnabled(window.outbrain_enable !== 0);

    console.log("[OUTBRAIN] Initial value:", window.outbrain_enable); // eslint-disable-line no-console
    // Set up polling to check for changes
    const intervalId = setInterval(() => {
      const newValue = window.outbrain_enable !== 0;

      if (newValue !== isOutbrainEnabled) {
        console.log("[OUTBRAIN] Value changed:", window.outbrain_enable); // eslint-disable-line no-console
        setIsOutbrainEnabled(newValue);
      }
    }, 5000); // Check every second

    // Cleanup interval on unmount
    return () => {
      clearInterval(intervalId);
    };
  }, [isOutbrainEnabled]);

  return isOutbrainEnabled;
}
